import ConsumerIcon from '../../assets/ConsumerIcon'
import ManageProductIcon from '../../assets/ManageProductIcon'
import PharmacyStoreIcon from '../../assets/PharmacyStoreIcon'
import SupplierIcon from '../../assets/SupplierIcon'
import CommissionIcon from '../../assets/CommissionIcon'
import PlatformChargesIcon from '../../assets/PlatformChargesIcon'
import PharmacyRequestIcon from '../../assets/PharmacyRequestIcon'
import ManageUserIcon from '../../assets/ManageUserIcon'
import UserIcon from '../../assets/UserIcon'
import ConsumerOrdersIcon from '../../assets/ConsumerOrdersIcon'

export const PAGE_CONST = {
  LOGIN: 'LOGIN',
  HOME: 'HOME',
  RESET_PASSWORD: 'RESET_PASSWORD',
  SETTINGS: 'SETTINGS',
  SETTINGS_MOBILE_MENU: 'SETTINGS_MOBILE_MENU',
  HELP: 'HELP',
  NOTIFICATION: 'NOTIFICATION',
}

export const MOBILE_SIDEMENU_VISIBLE_SCREENS = [
  PAGE_CONST.HOME,
  PAGE_CONST.SETTINGS,
  PAGE_CONST.HELP,
]

export const LOGIN_CONST = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  EMAIL: 'email',
  PHONE_NUMBER: 'mobileNumber',
  PASSWORD: 'password',
}

export const SETTINGS_CONST = {
  PHARMACY_STORE: 'Pharmacy Store',
  CONSUMER: 'Consumer',
  CONSUMER_ORDERS: 'Consumer Orders',
  SUPPLIER: 'Supplier/Manufacturer',
  MANAGE_USERS: 'Manage Users',
  MANAGE_PRODUCT: 'Manage Product',
  COMMISSION_EARNINGS: 'Commission Earnings',
  PLATFORM_CHARGES: 'Platform Charges',
  PHARMACY_REQUESTS: 'Pharmacy Requests',
  PHARMACY_INVENTORY: 'Manage Pharmacy Inventory',
  DELIVERY_MAN_MANAGEMENT: 'Delivery Man Management',
}

export const OTP_CONST = {
  SEND_OTP: 'SEND_OTP',
  VERIFY_OTP: 'VERIFY_OTP',
}

export const FORGOT_PASSWORD_STAGES = {
  SEND_OTP_STAGE: 'SEND_OTP_STAGE',
  VERIFY_OTP_STAGE: 'VERIFY_OTP_STAGE',
  PASSWORD_INPUT_STAGE: 'PASSWORD_INPUT_STAGE',
  SUCCESS_STAGE: 'SUCCESS_STAGE',
}

export const PERMISSION_TYPE = {
  VIEW: 'VIEW',
  MANAGE: 'MANAGE',
  RESTRICTED: 'RESTRICTED',
}

export const PERMISSION_FEATURE = {
  MANAGE_USERS: 'MANAGE_USERS',
  PHARMACY_STORE: 'PHARMACY_STORE',
  CONSUMER: 'CONSUMER',
  CONSUMER_ORDERS: 'CONSUMER_ORDERS',
  SUPPLIER: 'SUPPLIER',
  MANAGE_PRODUCT: 'MANAGE_PRODUCT',
  NEW_SUPPLIER_REQUEST: 'NEW_SUPPLIER_REQUEST',
  NEW_PRODUCT_REQUEST: 'NEW_PRODUCT_REQUEST',
  COMMISSION_EARNINGS: 'COMMISSION_EARNINGS',
  COMMISSION_EARNING_FROM_PHARMACY_STORE:
    'COMMISSION_EARNING_FROM_PHARMACY_STORE',
  COMMISSION_EARNING_FROM_SUPPLIER: 'COMMISSION_EARNING_FROM_SUPPLIER',
  PLATFORM_CHARGE: 'PLATFORM_CHARGE',
  PLATFORM_CHARGE_FROM_PHARMACY_STORE: 'PLATFORM_CHARGE_FROM_PHARMACY_STORE',
  PLATFORM_CHARGE_FROM_CONSUMER: 'PLATFORM_CHARGE_FROM_CONSUMER',
  PHARMACY_REQUESTS: 'PHARMACY_REQUESTS',
  PHARMACY_INVENTORY: 'PHARMACY_INVENTORY',
  SALES_ORDER: 'SALES_ORDER',
  SALES_AMOUNT: 'SALES_AMOUNT',
  REVENUE: 'REVENUE',
  USERS_ONBOARDED: 'USERS_ONBOARDED',
  BAR_CHART: 'BAR_CHART',
  QUERY: 'QUERY',
  DELIVERY_MAN_MANAGEMENT: 'DELIVERY_MAN_MANAGEMENT',
}

export const SETTINGS_NAVIGATION_ITEMS = [
  {
    name: SETTINGS_CONST.PHARMACY_STORE,
    profileDetailIcon: <PharmacyStoreIcon />,
    feature: PERMISSION_FEATURE.PHARMACY_STORE,
    id: 1,
  },
  {
    name: SETTINGS_CONST.CONSUMER,
    profileDetailIcon: <ConsumerIcon />,
    feature: PERMISSION_FEATURE.CONSUMER,
    id: 2,
  },
  {
    name: SETTINGS_CONST.CONSUMER_ORDERS,
    profileDetailIcon: <ConsumerOrdersIcon />,
    feature: PERMISSION_FEATURE.CONSUMER_ORDERS,
    id: 2,
  },
  {
    name: SETTINGS_CONST.SUPPLIER,
    profileDetailIcon: <SupplierIcon />,
    feature: PERMISSION_FEATURE.SUPPLIER,
    id: 2,
  },
  {
    name: SETTINGS_CONST.MANAGE_USERS,
    profileDetailIcon: <ManageUserIcon />,
    feature: PERMISSION_FEATURE.MANAGE_USERS,
    id: 2,
  },
  {
    name: SETTINGS_CONST.MANAGE_PRODUCT,
    profileDetailIcon: <ManageProductIcon />,
    feature: PERMISSION_FEATURE.MANAGE_PRODUCT,
    id: 2,
  },
  {
    name: SETTINGS_CONST.COMMISSION_EARNINGS,
    profileDetailIcon: <CommissionIcon />,
    feature: PERMISSION_FEATURE.COMMISSION_EARNINGS,
    id: 2,
  },
  {
    name: SETTINGS_CONST.PLATFORM_CHARGES,
    profileDetailIcon: <PlatformChargesIcon />,
    feature: PERMISSION_FEATURE.PLATFORM_CHARGE,
    id: 2,
  },
  {
    name: SETTINGS_CONST.PHARMACY_REQUESTS,
    profileDetailIcon: <PharmacyRequestIcon />,
    feature: PERMISSION_FEATURE.PHARMACY_REQUESTS,
    id: 2,
  },
  {
    name: SETTINGS_CONST.PHARMACY_INVENTORY,
    profileDetailIcon: <PharmacyStoreIcon />,
    feature: PERMISSION_FEATURE.PHARMACY_INVENTORY,
    id: 2,
  },
  {
    name: SETTINGS_CONST.DELIVERY_MAN_MANAGEMENT,
    profileDetailIcon: <UserIcon />,
    feature: PERMISSION_FEATURE.DELIVERY_MAN_MANAGEMENT,
    id: 2,
  },
]

export const ADD_USER_FLOW = {
  EDIT: 'EDIT',
}

export const ADD_USER_STAGES = {
  USER_DETAILS: 'USER_DETAILS',
  PERMISSIONS: 'PERMISSIONS',
}

export const USER_FIELDS = {
  NAME: 'name',
  PHONE_NUMBER: 'mobileNumber',
  AREA_CODE: 'areaCode',
  EMAIL: 'email',
  DESIGNATION: 'designation',
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'confirmPassword',
}

export const PERMISSION_NAME_MAPPING = {
  SETTINGS: 'Settings',
  MANAGE_USERS: 'Manage Users',
  PHARMACY_STORE: 'Pharmacy Store',
  CONSUMER: 'Consumer',
  CONSUMER_ORDERS: 'Consumer Orders',
  SUPPLIER: 'Supplier/Manufacturer',
  MANAGE_PRODUCT: 'Manage Product',
  NEW_SUPPLIER_REQUEST: 'New Supplier Request',
  NEW_PRODUCT_REQUEST: 'New Product Request',
  COMMISSION_EARNING_FROM_PHARMACY_STORE:
    'Commission Earning from Pharmacy Store',
  COMMISSION_EARNING_FROM_SUPPLIER:
    'Commission Earning from Supplier/Manufacturer',
  PLATFORM_CHARGE_FROM_PHARMACY_STORE: 'Platform Charge from Pharmacy Store',
  PLATFORM_CHARGE_FROM_CONSUMER: 'Platform Charge from Consumer',
  HOME_SCREEN: 'Home Screen',
  SALES_ORDER: 'Sales Order',
  SALES_AMOUNT: 'Sales Amount',
  REVENUE: 'Revenue',
  USERS_ONBOARDED: 'Users Onboarded',
  BAR_CHART: 'Bar Chart',
  OTHER: 'Other',
  QUERY: 'Query',
  PHARMACY_INVENTORY: 'Pharmacy Inventory',
}

export const PERMISSION_SCREEN = {
  SETTINGS: 'SETTINGS',
  HOME_SCREEN: 'HOME_SCREEN',
  OTHER: 'OTHER',
}

export function GET_PERMISSION_INITIAL_DATA() {
  return [
    {
      name: PERMISSION_SCREEN.SETTINGS,
      permissionList: [
        {
          name: PERMISSION_FEATURE.MANAGE_USERS,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.PHARMACY_STORE,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.CONSUMER,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.CONSUMER_ORDERS,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.SUPPLIER,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.MANAGE_PRODUCT,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.NEW_SUPPLIER_REQUEST,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.NEW_PRODUCT_REQUEST,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.COMMISSION_EARNING_FROM_PHARMACY_STORE,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.COMMISSION_EARNING_FROM_SUPPLIER,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_PHARMACY_STORE,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.PLATFORM_CHARGE_FROM_CONSUMER,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.PHARMACY_INVENTORY,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
      ],
    },
    {
      name: PERMISSION_SCREEN.HOME_SCREEN,
      permissionList: [
        {
          name: PERMISSION_FEATURE.SALES_ORDER,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.SALES_AMOUNT,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.REVENUE,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.USERS_ONBOARDED,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
        {
          name: PERMISSION_FEATURE.BAR_CHART,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
      ],
    },
    {
      name: PERMISSION_SCREEN.OTHER,
      permissionList: [
        {
          name: PERMISSION_FEATURE.QUERY,
          permissionType: PERMISSION_TYPE.RESTRICTED,
        },
      ],
    },
  ]
}

export const ACTIVE_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DELETE: 'Delete',
}

export const APPROVAL_STATUS = {
  APPROVE: 'Approve',
  REJECT: 'Reject',
}

export const SUPPLIER_FIELDS = {
  NAME: 'name',
  PHONE_NUMBER: 'mobileNumber',
  ADDRESS: 'address',
}

export const PRODUCT_DETAIL_FIELDS = {
  PRODUCT_ID: 'productId',
  PRODUCT_UNDERSCORE_ID: 'product_id',
  PRODUCT_CATEGORY: 'type',
  PRODUCT_NAME: 'name',
  PRODUCT_BARCODE: 'barcode',
  SELECTED_PRODUCT: 'selectedProduct',
  GENERIC_NAME: 'generic_name',
  PRODUCT_IMAGE: 'product_image',
  MEDICAL_CATEGORY: 'category',
  SUPPLIER: 'supplier',
  ORIGIN: 'origin',
  PRESCRIPTION_REQUIRED: 'is_prescription_required',
  BATCH_NUMBER: 'batch_number',
  EXPIRY_DATE: 'expiry_date',
  DOSE: 'dose',
  QUANTITY: 'quantity',
  BONUS_QUANITY: 'bonus_quantity',
  NUMBER_OF_STRIP: 'number_of_strip',
  MED_PER_STRIP: 'medicine_per_strips',
  BONUS_STRIP: 'bonus_strip',
  PRODUCT_COST: 'cost_per_unit',
  VAT_PERCENTAGE: 'vat',
  PRODUCT_NEW_COST: 'new_cost_per_unit',
  RATE_PER_UNIT: 'rate_per_unit',
  FINAL_PRICE: 'final_price',
  TOTAL_AMOUNT: 'total_amount',
  NEW_QUANTITY: 'new_quantity',
  CURRENT_QUANTITY: 'current_quantity',
  SELECTED_BATCH_DETAILS: 'selected_batch_details',
  STOCK: 'stock',
  INVENTORY: 'inventory',
}

export const PHARMACY_REQUEST_TYPE = {
  SUPPLIER: 'SUPPLIER',
  PRODUCT: 'PRODUCT',
}

export const COMMISSION_EARNINGS_TYPE = {
  PHARMACY_STORE: 'Pharmacy Store',
  SUPPLIER: 'Supplier/Manufacturer',
}

export const PLATFORM_CHARGE_TYPE = {
  PHARMACY_STORE: 'Pharmacy Store',
  CUSTOMER: 'Customer',
}

export const PRODUCT_ORIGIN = {
  FOREIGN: 'FOREIGN',
  LOCAL: 'LOCAL',
}

export const PRODUCT_CATEGORY = {
  PHARMACEUTICAL: 'PHARMACEUTICAL',
  NON_PHARMACEUTICAL: 'NON_PHARMACEUTICAL',
}

export const INVENTORY_DETAIL_FIELDS = {
  BATCH_NUMBER: 'batch_number',
  EXPIRY_DATE: 'expiry_date',
  QUANTITY: 'quantity',
  BONUS_QUANTITY: 'bonus_quantity',
  TOTAL_PRICE: 'total_price',
  RATE_PER_UNIT: 'rate_per_unit',
}

export const DESIGNATION = {
  SUPER_ADMIN: 'SUPER_ADMIN',
}

export const TOTAL_EARNING_TAB = {
  WEEK: 'week',
  MONTH: 'month',
  THREE_MONTHS: '3_months',
  SIX_MONTHS: '6_months',
  YEAR: 'year',
}

export const QUERY_TAB_TYPE = {
  EPHARMA: 'PHARMACY_STORE',
  EMED: 'CONSUMER',
}

export const QUERY_STATUS = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
}

export const QUERY_STATUS_OPTIONS = [
  { name: 'NEW', label: 'New' },
  { name: 'IN_PROGRESS', label: 'In Progress' },
  { name: 'RESOLVED', label: 'Resolved' },
  { name: 'CLOSED', label: 'Closed' },
]
